import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAggregatedOrderFulfillmentDataByTypeV2QueryVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
  start_date?: Types.InputMaybe<Types.Scalars['String']>;
  end_date?: Types.InputMaybe<Types.Scalars['String']>;
  event_account_ids?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
}>;


export type GetAggregatedOrderFulfillmentDataByTypeV2Query = { __typename?: 'Query', getAggregatedOrderFulfillmentDataByTypeV2: { __typename?: 'GetAggregatedOrderFulfillmentDataByTypeV2Result', container_types: Array<{ __typename?: 'AggregatedItemDataV2', item_info: { __typename?: 'ItemInfo', id: string, name: string, image_url?: string | null, color_hex_code?: string | null }, fulfillment_type_counts: Array<{ __typename?: 'OrderFulfillmentTypeCountV2', fulfillment_type: Types.OrderFulfillmentType, amount: number, amount_sealed: number, amount_container_stations: number, amount_container_stations_sealed: number }> }>, container_stations: Array<{ __typename?: 'AggregatedItemDataV2', item_info: { __typename?: 'ItemInfo', id: string, name: string, image_url?: string | null, color_hex_code?: string | null }, fulfillment_type_counts: Array<{ __typename?: 'OrderFulfillmentTypeCountV2', fulfillment_type: Types.OrderFulfillmentType, amount: number, amount_sealed: number, amount_container_stations: number, amount_container_stations_sealed: number }> }>, assets: Array<{ __typename?: 'AggregatedItemDataV2', item_info: { __typename?: 'ItemInfo', id: string, name: string, image_url?: string | null, color_hex_code?: string | null }, fulfillment_type_counts: Array<{ __typename?: 'OrderFulfillmentTypeCountV2', fulfillment_type: Types.OrderFulfillmentType, amount: number, amount_sealed: number, amount_container_stations: number, amount_container_stations_sealed: number }> }> } };


export const GetAggregatedOrderFulfillmentDataByTypeV2Document = gql`
    query GetAggregatedOrderFulfillmentDataByTypeV2($event_id: ID!, $start_date: String, $end_date: String, $event_account_ids: [ID!]) {
  getAggregatedOrderFulfillmentDataByTypeV2(
    event_id: $event_id
    start_date: $start_date
    end_date: $end_date
    event_account_ids: $event_account_ids
  ) {
    container_types {
      item_info {
        id
        name
        image_url
        color_hex_code
      }
      fulfillment_type_counts {
        fulfillment_type
        amount
        amount_sealed
        amount_container_stations
        amount_container_stations_sealed
      }
    }
    container_stations {
      item_info {
        id
        name
        image_url
        color_hex_code
      }
      fulfillment_type_counts {
        fulfillment_type
        amount
        amount_sealed
        amount_container_stations
        amount_container_stations_sealed
      }
    }
    assets {
      item_info {
        id
        name
        image_url
        color_hex_code
      }
      fulfillment_type_counts {
        fulfillment_type
        amount
        amount_sealed
        amount_container_stations
        amount_container_stations_sealed
      }
    }
  }
}
    `;

/**
 * __useGetAggregatedOrderFulfillmentDataByTypeV2Query__
 *
 * To run a query within a React component, call `useGetAggregatedOrderFulfillmentDataByTypeV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetAggregatedOrderFulfillmentDataByTypeV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAggregatedOrderFulfillmentDataByTypeV2Query({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *      event_account_ids: // value for 'event_account_ids'
 *   },
 * });
 */
export function useGetAggregatedOrderFulfillmentDataByTypeV2Query(baseOptions: Apollo.QueryHookOptions<GetAggregatedOrderFulfillmentDataByTypeV2Query, GetAggregatedOrderFulfillmentDataByTypeV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAggregatedOrderFulfillmentDataByTypeV2Query, GetAggregatedOrderFulfillmentDataByTypeV2QueryVariables>(GetAggregatedOrderFulfillmentDataByTypeV2Document, options);
      }
export function useGetAggregatedOrderFulfillmentDataByTypeV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAggregatedOrderFulfillmentDataByTypeV2Query, GetAggregatedOrderFulfillmentDataByTypeV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAggregatedOrderFulfillmentDataByTypeV2Query, GetAggregatedOrderFulfillmentDataByTypeV2QueryVariables>(GetAggregatedOrderFulfillmentDataByTypeV2Document, options);
        }
export type GetAggregatedOrderFulfillmentDataByTypeV2QueryHookResult = ReturnType<typeof useGetAggregatedOrderFulfillmentDataByTypeV2Query>;
export type GetAggregatedOrderFulfillmentDataByTypeV2LazyQueryHookResult = ReturnType<typeof useGetAggregatedOrderFulfillmentDataByTypeV2LazyQuery>;
export type GetAggregatedOrderFulfillmentDataByTypeV2QueryResult = Apollo.QueryResult<GetAggregatedOrderFulfillmentDataByTypeV2Query, GetAggregatedOrderFulfillmentDataByTypeV2QueryVariables>;